// Lucide icon: rotate-ccw-clock (https://lucide.dev/icons/rotate-ccw-clock)
import { RotateCcwClock } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconActionHistory = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <RotateCcwClock />
    </IconComponentStyled>
  )
}
